import 'css/src/global';

import React from 'react';

import { Urls } from 'js/src/client';
import Copyright from 'js/src/components/auth/common/Copyright';
import Sidebar from 'js/src/components/auth/common/Sidebar';
import Title from 'js/src/components/auth/common/Title';
import ForgotPasswordForm from 'js/src/components/auth/forgotPassword/ForgotPasswordForm';

const ForgotPasswordPage = React.memo(function ForgotPasswordPage() {
    return (
        <div className="row">
            <div className="col-md-4 d-none d-md-block">
                <Sidebar />
            </div>
            <div className="col-md-8 col-sm-12 d-flex justify-content-center">
                <div className="details-form">
                    <div className="form-sidebar vertical-flex xs-fill-height">
                        <div className="flex-spacer">
                            {/* Spaces out top in the form on desktop */}
                            <div className=" auth-base-logo d-block d-md-none mb-l5-48">
                                <a href="/">
                                    <img
                                        src="https://cdn.lumen5.com/lumen5-site-images/L5-logo/2024/Lumen5-PrimaryLogo.svg"
                                        alt="Lumen5"
                                        width="125"
                                    />
                                </a>
                            </div>
                        </div>
                        <div className="login-form main-content">
                            <Title title="Forgot your password?" />
                            <ForgotPasswordForm />
                        </div>
                        <div>
                            <a className="fw-semibold" href={Urls.LOGIN}>
                                Return to login
                            </a>
                        </div>
                        <Copyright />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ForgotPasswordPage;
